import React from 'react'
import TabMenu from '../../../components/TabMenu/TabMenu'
import { Outlet } from 'react-router-dom'
import { useGetAdminStats } from '../../../api/admin/useGetAdminStats'
import { formatNumber } from '../../../lib/utils/formatNumber'
import { PageHeader } from '@demandlocal/components'
import { useSelector } from 'react-redux'
import { currentUserSelector } from '../../../store/selectors/userSelector'
import Error404 from '../../../components/404'

const AdminTemplate = (): JSX.Element => {
  const { data } = useGetAdminStats()
  return (
    <div className={'flex flex-1 flex-col'}>
      <PageHeader
        cardsOptions={[
          {
            title: 'Agencies',
            content: formatNumber(data?.organizations),
            color: 'bg-chrysler-blue/20',
          },
          {
            title: 'Active Dealerships',
            content: formatNumber(data?.dealerships),
            color: 'bg-blue-aero/20',
          },
          {
            title: 'Total Users',
            content: formatNumber(data?.users),
            color: 'bg-pumpkin/20',
          },
        ]}
        title={'Admin'}
      />

      <div className={'flex flex-1 flex-col px-10 max-w-[1920px] mx-auto w-full'}>
        <div className={'mt-12 mb-10'}>
          <TabMenu
            options={[
              { name: 'Users', to: 'users' },
              { name: 'Agencies', to: 'organizations' },
              { name: 'Dealerships', to: 'dealerships' },
              { name: 'Integrations', to: 'integrations' },
              { name: 'Partners', to: 'partners' },
            ]}
          />
        </div>
        <Outlet />
      </div>
    </div>
  )
}

const Admin = (): JSX.Element => {
  const user = useSelector(currentUserSelector)
  if ((user?.role_id ?? 3) > 1) return <Error404 />

  return <AdminTemplate />
}

export default Admin
